import {  LOGIN_SUCCESS, LOGIN_FAIL } from "../actions/types";
const initialState=  {
    
    isAuthenticated:false,
 
    user:null,

}

export default function(state=initialState,action){
    const {type,payload}  = action;
    switch(type){
        case LOGIN_SUCCESS:
         
            
            return {
                ...state,
               
                isAuthenticated:true,
                user:payload,
                
            }

        
        case LOGIN_FAIL:
       
        return {
            ...state,
             
            isAuthenticated:false,
        
        }
        
        default:
            return state;
                
    }
}